import { render, staticRenderFns } from "./order-observation.vue?vue&type=template&id=59fcaa88"
import script from "./order-observation.vue?vue&type=script&lang=js"
export * from "./order-observation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports